<div class="page">
  <app-company-header></app-company-header>
  <div class="mainContainer">
    <ng-container *ngIf="us.currentUser">
      <router-outlet></router-outlet>
    </ng-container>
  </div>
  <app-portal name="footer"></app-portal>
</div>
